import OnboardingForm from '../features/onboarding/OnboardingForm';

function OnboardingPage(): JSX.Element {
    return (
        <div className="h-screen w-screen">
            <OnboardingForm />
        </div>
    );
}

export default OnboardingPage;
